import { rankWith, uiTypeIs } from '@jsonforms/core'

// Tells Jsonforms which control/component should be used.
export default rankWith(Number.MAX_VALUE, uiTypeIs('FileInput'))
